// admin-client/src/pages/Dashboard.js
import React from 'react';
import AgentTreePage from './Admin/AgentTreePage';

/**
 * Dashboard
 * - 대시보드 상단의 중복 "생성" 버튼/로직 제거
 * - 에이전트/유저 트리 화면은 Admin/AgentTreePage에서 전담
 * - 이 파일은 래퍼 역할만 수행
 */
export default function Dashboard() {
  return (
    <div className="min-h-screen">
      <AgentTreePage />
    </div>
  );
}